export default "__VITE_ASSET__7aaiIgdG__"